import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames'
import css from './index.css'
import Button from '~/components/common/Button';
import {modalClose, modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import {push as changeURL} from 'react-router-redux';


class LoadDisapper extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const {closePop} = this.props;
    return (
      <div className={css.popwrap}>
        <header className={css.title}>
          <p>Oops!</p>
        </header>
        <main className={css.mainNormal}>
          The load is no longer available, we have searched more loads for you!
        </main>
        <footer className={css.footer}>
          <div className={css.footerRow}>
            <Button
              mods={['action']}
              onClick={closePop}
              className={css.button}
            >
              Ok, got it
            </Button>
          </div>
        </footer> 
      </div>
    )
  }
}

export default connect(null, mapDispatch({
  closePop: () => modalClose(modes.LOAD_DISAPPER)
}))(LoadDisapper);


// WEBPACK FOOTER //
// ./src/components/Popup/LoadsDisapper/index.js